import React from 'react';
import { Box, Typography } from '@mui/material';
import { StorefrontOutlined } from '@mui/icons-material';
import { SectionPaper } from '../../../../common/components/styled-ui-elements';

interface VendorEmptyStateProps {
  message?: string;
}

const VendorEmptyState: React.FC<VendorEmptyStateProps> = ({
  message = 'No vendors found.',
}) => {
  return (
    <SectionPaper>
      <Box display="flex" flexDirection="column" alignItems="center" py={4}>
        <StorefrontOutlined sx={{ fontSize: 48, color: '#94a3b8', mb: 1 }} />
        <Typography variant="body1" color="#64748b">
          {message}
        </Typography>
      </Box>
    </SectionPaper>
  );
};

export default VendorEmptyState;
